<template>
  <b-button-toolbar>
    <b-button @click="showModal=!showModal"> 
      <i class="fa fa-photo mr-2" /> Toevoegen foto
    </b-button>
    <b-modal 
      v-model="showModal" 
      title="Kies foto" 
      size="lg"
    >
      <media-grid
        :url="url"
        :uploadfolder="uploadfolder"
        @foto-select="(foto) => { $emit('foto-select',foto); showModal = false; }"
      />
    </b-modal>
  </b-button-toolbar>
</template>
<script>
    import MediaGrid from '../components/MediaGrid.vue';
    export default {
        name: 'KiesFoto',
        components: {
            MediaGrid
        },
        mixins: [],
        props: {
            path: {
                type: String,
                default: null
            }
        },
        data() {
            return  {
                showModal: false
            }
        },
        computed: {
            url: function() {
                return `/media/cloudinary/${this.path}`;
            },
            uploadfolder: function() {
                return `/data/${this.path}`;
            }
        },
        watch: {},
        mounted () {
            
        },
        methods: {},
              
    }
</script>